export default {
  CargosPartidarios: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "cargo-partidario"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CargosPartidarios.js
// module id = j7x9
// module chunks = 13